import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-column footer-brand">
                        <h4>AI Consulting SA</h4>
                        <p>AI strategy, machine learning delivery, and automation programs for South African enterprises.</p>
                    </div>

                    <div className="footer-column">
                        <h4>Company</h4>
                        <Link to="/about">About</Link>
                        <Link to="/services">Services</Link>
                        <Link to="/case-studies">Case Studies</Link>
                    </div>

                    <div className="footer-column">
                        <h4>Start</h4>
                        <Link to="/readiness">AI Readiness</Link>
                        <Link to="/contact">Contact</Link>
                        <a href="mailto:strategy@aiconsultingsa.co.za">Email Strategy Desk</a>
                    </div>

                    <div className="footer-column">
                        <h4>Connect</h4>
                        <div className="social-links">
                            <a href="https://www.linkedin.com/company/ai-consulting-sa" target="_blank" className="social-link" aria-label="LinkedIn" rel="noreferrer">
                                <i className="fab fa-linkedin-in" aria-hidden="true"></i>
                            </a>
                            <a href="mailto:strategy@aiconsultingsa.co.za" className="social-link" aria-label="Email">
                                <i className="fas fa-envelope" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="copyright">
                    <p>&copy; {year} AI Consulting South Africa. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
